import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  PrimaryLinksComponentProps,
  PrimaryLinksDataProps,
  PrimaryLinksThemeProps,
} from '../../components/navigation/header/primaryHeader/PrimaryLinks';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { useTheme } from '../../../theming/useTheme';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../partials/link/TextLink';
import { HeaderLinksDataProps } from '../../components/navigation/header/Header';
import { getGeneratedGlobalStyles } from '../../../typography/globalTypographyStyles';
import { VrLineHeight } from '../../../theming/verticalRhythm/verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';

const additionalStyle = {
  [MEDIA_BREAKPOINTS.X_LARGE]: {
    display: 'block',
  },
  [MEDIA_BREAKPOINTS.LARGE]: {
    display: 'block',
  },
  [MEDIA_BREAKPOINTS.MEDIUM]: {
    display: 'none',
  },
  [MEDIA_BREAKPOINTS.SMALL]: {
    display: 'none',
  },
};

const radiusBorder = 4;

const createStyle = (isActive:boolean = false, activeBorderBottom:string) => {
  return StyleSheet.create({
    link: {
      height: '100%',
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      ':before': isActive ? {
        height: `${radiusBorder}px`,
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        content: "''",
        backgroundColor: activeBorderBottom,
      } : {},
    },
  });
};

const createLink = (idleColor:string, vrLineHeight:VrLineHeight, activeBorderBottom:string, hoverStateColor:string, activeStateColor:string, pagePath: string) => (link:HeaderLinksDataProps, index: number) => {
  const { href, text } = link;
  const isActiveLink = href === pagePath;
  const contentStyle = StyleSheet.create(isActiveLink ? getGeneratedGlobalStyles().h4() : getGeneratedGlobalStyles().p());
  const linkStyle = generateLinkStyleFromTheme({ idleColor, activeStateColor, hoverStateColor }, additionalStyle);
  const style = createStyle(isActiveLink, activeBorderBottom);
  return (
    <TextLinkComponent key={index} href={href} linkStyle={linkStyle}>
      <span className={css(contentStyle.style, style.link)}>{text}</span>
    </TextLinkComponent>
  );
};

export const AMPPrimaryLinksComponent:React.FunctionComponent<PrimaryLinksComponentProps> = props => {
  const { links, idleColor, vrLineHeight, activeBorderBottom, hoverStateColor, activeStateColor, pagePath } = props;
  return (
    <React.Fragment>
      {links.map(createLink(idleColor, vrLineHeight, activeBorderBottom, hoverStateColor, activeStateColor, pagePath))}
    </React.Fragment>
  );
};

const componentConfigThemeKey = 'primaryLinks';

const mapThemeProps = (theme: PrimaryLinksThemeProps) => {
  return {
    idleColor: theme.idleColor,
    activeStateColor: theme.activeStateColor,
    hoverStateColor: theme.hoverStateColor,
    activeBorderBottom: theme.activeBorderBottom,
    hoverOtherLinksColors: theme.hoverOtherLinksColors,
    vrLineHeight: theme.vrLineHeight,
  };
};

export const AMPPrimaryLinks = (props: PrimaryLinksDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <ErrorBoundary><AMPPrimaryLinksComponent {...themeContext} {...props} /></ErrorBoundary>;
};
